module.exports = {"user":{"no":"no.","name":"ชื่อ","empId":"รหัสพนักงาน","isAdmin":"สิทธิ Admin","isNpiAdmin":"สิทธิ Npi","manage":"รายละเอียด ผู้ใช้งาน","costCenterName":"หน่วยงาน","viewList":"รายละเอียดผู้ใช้งาน","manageNpi":"จัดการ สิทธิ NPI","manageAdmin":"จัดการ สิทธิ Admin","edit":"แก้ไข","submitNpiPermit":"Submit","cancel":"Cancel","backToList":"กลับหน้า รายละเอียดผู้ใช้งาน","manageSubmit":"Manage Submit","manageApprove":"Manage Approve","isSubmit":"Is Submit","isApprove":"Is Approve","":""}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/user.json
// module id = 563
// module chunks = 35